import { useTranslation } from 'react-i18next'
import { getTenantDetailsTableCopy } from 'ClientPortal/src/common/tenantDetailsTable'
import { TenantImportTool } from '@einwert/tenant-import'
import { usePlaygroundFeedback } from '../usePlaygroundFeedback'
import { usePlaygroundTranslations } from '../usePlaygroundTranslations'
import { useTenantListImport } from './TenantListImportPage.data'
import { getTenantBreakdownTableCopy } from '../../Assets/AssetDetails/Valuation/tenantBreakdownTableCopy'

export function TenantListImportPage() {
    const { feedbackButton } = usePlaygroundFeedback()
    const { t, i18n } = useTranslation('pages', { keyPrefix: 'playground.tenantListImport' })
    const { t: tCommon } = useTranslation('terminology', { keyPrefix: 'common' })
    const { t: tTenantBreakdownTable } = useTranslation('terminology', { keyPrefix: 'common.tenantBreakdownTable' })
    const { t: tTenantListPage } = useTranslation('pages', { keyPrefix: 'assets.assetDetails.valuation.valuationTenantListPage' })
    const { t: tTenantDetailsTable } = useTranslation('pages', {
        keyPrefix: 'assets.assetDetails.valuation.valuationTenantListPage.tenantDetailsTable',
    })
    const { t: tTenantRentalStatuses } = useTranslation('terminology', { keyPrefix: 'common.tenantRentalStatuses' })
    const { t: tActions } = useTranslation('terminology', { keyPrefix: 'common.actions' })
    const { dashboardBreadcrumbRoot, toolHeaderCopy } = usePlaygroundTranslations()
    const language = i18n.language.startsWith('en') ? 'en' : 'de'
    const data = useTenantListImport(language)
    return (
        <TenantImportTool
            data={data}
            feedbackButton={feedbackButton}
            breadcrumbRoot={dashboardBreadcrumbRoot}
            headerCopy={toolHeaderCopy}
            summaryCopy={getTenantBreakdownTableCopy(tCommon, tTenantBreakdownTable)}
            tableCopy={getTenantDetailsTableCopy(tCommon, tTenantRentalStatuses, tTenantDetailsTable)}
            toolCopy={{
                title: t('title'),
                infoText: t('infoText'),
                emptyDescription: t('emptyDescription'),
                upload: tActions('upload'),
                cancel: tActions('cancel'),
                replaceFile: t('replaceFile'),
                readyToDownload: t('readyToDownload'),
                rowsLabel: (count) => tTenantListPage('rowsLabel', { count }),
                format: {
                    title: t('format.title'),
                    template: t('format.template'),
                    periods: t('format.periods'),
                    remarks: t('format.remarks'),
                },
                exportLimitations: (count) => t('exportLimitations', { count }),
            }}
        />
    )
}
